import { FileItem } from "./Files"

export const generateID = (role: "assistant" | "user") => {
    const prefix = role === "user" ? "US-" : role === "assistant" ? "AS-" : ""
    return (
        prefix +
        Array.from(
            { length: 12 },
            () => "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(Math.random() * 36)]
        ).join("")
    )
}

// Helper function to find the parent folder of an item
export const findParentFolder = (tree: FileItem[], itemId: string): FileItem | null => {
    for (const item of tree) {
        if (item.children) {
            if (item.children.some((child) => child._id === itemId)) {
                return item
            }
            const parent = findParentFolder(item.children, itemId)
            if (parent) return parent
        }
    }
    return null
}

// Ensure tree has folders first, and files sorted from oldest to newest
export const sortTree = (items: FileItem[]): FileItem[] => {
    const sortedItems = [...items].sort((a, b) => {
        if (a.type === "folder" && b.type !== "folder") return -1
        if (a.type !== "folder" && b.type === "folder") return 1
        return a.created - b.created
    })
    return sortedItems.map((item) => ({
        ...item,
        children: item.children ? sortTree(item.children) : undefined,
    }))
}

export const truncateFileName = (name: string) => {
    if (name.length <= 30) return name
    return name.slice(0, 27) + "..."
}

export const bytesToReadable = (bytes?: number) => {
    if (!bytes) return null
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"]
    if (bytes === 0) return "0 Byte"
    const i = Math.floor(Math.log(bytes) / Math.log(1024))
    return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i]
}

export const readableFileDate = (date: number) => {
    const d = new Date(date)
    const hours = d.getHours()
    const minutes = d.getMinutes().toString().padStart(2, "0")
    const ampm = hours >= 12 ? "PM" : "AM"
    const formattedHours = hours % 12 || 12 // Convert to 12-hour format
    return `${
        d.getMonth() + 1
    }/${d.getDate()}/${d.getFullYear()} ${formattedHours}:${minutes} ${ampm}`
}

export const filterTree = (tree: FileItem[], search: string): FileItem[] => {
    if (!search) return tree
    const lowerSearch = search.toLowerCase()
    const filterNode = (node: FileItem): FileItem | null => {
        const matches = node.name.toLowerCase().includes(lowerSearch)
        const filteredChildren =
            node.children?.map(filterNode).filter((child): child is FileItem => child !== null) ||
            []
        if (matches || filteredChildren.length > 0) {
            return { ...node, children: filteredChildren }
        }
        return null
    }
    return tree.map(filterNode).filter((node): node is FileItem => node !== null)
}
